module.exports = __webpack_public_path__ + "images/citroen_small83927ae2fbd9b1b23c06edfb1387511d.png";